export default __webpack_public_path__ + "static/media/product-right.1ceb81e9.png";